import React, { useState } from 'react';
import HanTableContainer from '../../../../utils/han-table-components/HanTableContainer';
import HanTableHead from '../../../../utils/han-table-components/HanTableHead';
import HanTable, { HanTableCell, HanTableRow } from '../../../../utils/han-table-components/HanTable';
import { ReactComponent as ChevronDownPink } from '../../../../../assets/icons/icon_chevron_down_pink.svg';
import { ReactComponent as ChevronUpPink } from '../../../../../assets/icons/icon_chevron_up_pink.svg';
import University from '../../../../../networking/models/University';

interface Props {
    university: University;
}

const UniversityGeneralCosts: React.FC<Props> = ({ university }) => {
    const initialCommentAmount = 3;

    const [commentAmount, setCommentAmount] = useState(initialCommentAmount);

    const showLess = () => setCommentAmount(initialCommentAmount);

    return (
        <div className="university-general__costs">
            <h2 className="university-general__costs-title">COSTS</h2>

            <div className="university-general__costs-tables-container">
                <div className="university-general__costs-table-container">
                    <HanTableContainer className="university-general__costs-table">
                        <HanTableHead>
                            Monthly costs approximately
                        </HanTableHead>
                        <HanTable borderOrientation={"vertical"}>
                            {
                                university.costs !== undefined &&
                                university?.costs.map((cost, index) => {
                                    return (
                                        <HanTableRow modifiers={index % 2 !== 0 ? "alabaster" : ""} key={index}>
                                            <HanTableCell modifiers={["left"]}>{cost.question}</HanTableCell>
                                            <HanTableCell modifiers={["right"]}>
                                                €{cost.value}
                                            </HanTableCell>
                                        </HanTableRow>
                                    )
                                })
                            }

                            <HanTableRow modifiers={"border-top"}>
                                <HanTableCell modifiers={["left", "bold"]}>Total costs</HanTableCell>
                                <HanTableCell modifiers={["right", "bold"]}>€{university?.totalCost}</HanTableCell>
                            </HanTableRow>
                        </HanTable>
                    </HanTableContainer>
                </div>

                <div className="university-general__costs-table-container">
                    <HanTableContainer>
                        <HanTableHead>
                            General comments about costs
                        </HanTableHead>
                        <HanTable>
                            {
                                university.costsComments?.map((comment, index) => {
                                    if (index + 1 > commentAmount) return null;

                                    return (
                                        <HanTableRow modifiers={index % 2 !== 0 ? "alabaster" : ""} key={index}>
                                            <HanTableCell modifiers={["left"]}>{comment}</HanTableCell>
                                        </HanTableRow>
                                    )
                                })
                            }
                        </HanTable>
                    </HanTableContainer>

                    {
                        university.costsComments !== undefined ?
                            initialCommentAmount < university.costsComments.length ?
                                commentAmount < university.costsComments.length ?
                                    <p
                                        className="university-general__show-more"
                                        onClick={() =>
                                            commentAmount + 3 < university.costsComments!.length ?
                                                setCommentAmount(commentAmount + 3) :
                                                setCommentAmount(university.costsComments!.length)
                                        }
                                    >
                                        Show more <ChevronDownPink />
                                    </p>
                                    :
                                    commentAmount >= university.costsComments!.length &&
                                    <p
                                        className="university-general__show-more"
                                        onClick={showLess}
                                    >
                                        Show less <ChevronUpPink />
                                    </p>
                                :
                                <></>
                            :
                            <></>
                    }
                </div>
            </div>
        </div>
    )
}

export default UniversityGeneralCosts;
